import React, { Component } from 'react'
import * as Media from '../../utils/Breakpoints'
import VisibilitySensor from 'react-visibility-sensor'
import moment from 'moment'
import {TweenMax, Linear} from "gsap/TweenMax"

Number.prototype.pad = function(size) {
  var s = String(this);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}

class Video extends Component {

	constructor(props) {
    super(props);
    this.state = {
    	"playButton": "Play",
    	"playPause": "is-playing",
    	"min": 0,
    	"sec": 0,
    	"transition": "transition-on",
    	"hover": ""
    };
    
    this.onChange = this.onChange.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
    this.timer = this.timer.bind(this);
    this.seek = this.seek.bind(this);
    this._mouseEnter = this._mouseEnter.bind(this);
    this._mouseLeave = this._mouseLeave.bind(this);
  }


  onChange(isVisible) {

  	if(isVisible) {
  		this.refs.video.play();
  	} else {
  		this.refs.video.pause();
  	}
  
  }

  _mouseEnter() {
  	this.setState({"hover": "is-hover"});
  }

  _mouseLeave() {
  	this.setState({"hover": ""});
  }

  togglePlayPause(event) {
  	
  	let video = this.refs.video;
  	let playpause = event.target;

  	if (video.paused || video.ended) {
      playpause.title = "pause";
     
      this.setState({ "playPause": "is-playing", "playButton": "Pause", "transition": "transition-on"});

      video.play();
   }
   else {
      playpause.title = "play";
     
      this.setState({ "playPause": "is-not-playing", "playButton": "Play", "transition": "transition-off"});

      video.pause();
   }
  }

  updateProgress() {

  let video = this.refs.video;
	let progress = this.refs.progress;
	let value = 0;

	if(video.currentTime > 0 && video != undefined) {
		value = Math.floor((100/video.duration) * video.currentTime);
	}

	// TweenMax.to(progress, 1, {left: value+"%"});
	progress.style.left = value+"%";



  }

  timer() {

  	let video = this.refs.video;
  	let timer = this.refs.timer;
  	let duration = Math.floor(video.duration);
  	let currentTime = Math.floor(video.currentTime);
  	let secondsLeft = (duration-currentTime);

  	let dur = moment.duration(secondsLeft,'seconds');
  	let minutes = dur.minutes().pad(2);
  	let seconds = dur.seconds().pad(2);

  	this.setState({ "min": minutes, "sec": seconds });

  }

  seek(event) {

  	let video = this.refs.video;
  	let progress = this.refs.progress;
  	let x = event.offsetX;
  	let w = event.target.offsetWidth;
  	let percent = (x/w);
  	
  	video.currentTime = percent * video.duration; 
  	
  }



  componentDidMount() {

  	if(this.props.controls) {
  		
  		let video = this.refs.video;
  		let progressBar = this.refs.progressContainer;
  		let progress = this.refs.progress;
  		let _this = this;
  		video.controls = false;

      if(video != undefined ) {

  		video.addEventListener('timeupdate', function() { 

  			_this.updateProgress();
  			_this.timer();
  		
      }, false);

  		// sets the prgroess to 0, plays the video and sets the transition state on the progressbar
  		video.addEventListener('ended', function() { 
  			_this.setState({"transition": "transition-off" });
  			progress.style.left = 0;

  			setTimeout(function() { 
  				video.play();
	  			_this.setState({"transition": "transition-on" });
  			}, 100);
  			
  		}, false);

  	
  		progressBar.addEventListener('mousedown', this.seek ,false);

  		}
  	}
  }



  
  render() {

  	const {ratio,fluid,playOnVisible,controls} = this.props;

	const ratioStyle = {

  		paddingTop:(100 / (ratio))+'%'

  	}

  	const fluidStyle = {

  		width:'100%',
  		height:'100%',
      position:'absolute',
      top:0,
      left:0

  	}


  	const style = (fluid) ? fluidStyle : ratioStyle;
    let className = this.props.className || 'video';


    if(playOnVisible) {

    	return (

			<VisibilitySensor onChange={this.onChange} partialVisibility={true} offsetoff={{top:-100}}>
		      <div className={'Image  Image--'+className} ref="image" style={style}>
		        <video className={"Video "+this.state.playPause+" "+this.state.hover} ref="video" onMouseEnter={this._mouseEnter} onMouseLeave={this._mouseLeave} webkit-playsinline="true" playsInline muted controls={controls} autoPlay={this.props.autoplay}>
		          <source src={this.props.src} type="video/mp4" />
		        </video>

		        <div className={"Video-controls "+this.state.hover}>
		        	
		        	<div className="Video-controls-container" onMouseEnter={this._mouseEnter} onMouseLeave={this._mouseLeave}>
				    
				        <button className={"Video-controls-playPause "+this.state.playPause} ref="playPause" id="playpause" title="play" onClick={this.togglePlayPause}>{this.state.playButton}</button>
				        <div className="Video-controls-progressContainer" ref="progressContainer">
					        <span className="Video-controls-progressBar"></span>
				        	<span className={"Video-controls-progress "+ this.state.transition} ref="progress"></span>
				        </div>
				        <div className="Video-controls-timer" id="timer" ref="timer"><span>{this.state.min} . {this.state.sec}</span></div>
			        
			        </div>

		        </div>

		      </div>


		  	</VisibilitySensor>

	    );

    } else {

    	return (
	      	<div className={'Image Image--'+className} ref="image" style={style}>
    	      
    	      <video className="Video" webkit-playsinline="true" playsInline loop muted controls={controls} autoPlay={this.props.autoplay}>
    	    	<source src={this.props.src} type="video/mp4" />
	          </video>

	      	</div>
	    );
    }
    
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/js/components/Video/Video.jsx